export default __webpack_public_path__ + "static/media/pilcrow.092c50fd.svg";